import { ACMEListResponse } from '@b2b/types/core';
import { FormsSummariesListItem } from '@b2b/types/forms';
import { IInjectable, StateParams } from '@uirouter/angularjs';
import { IPromise } from 'angular';
import { ApiService } from '../services/api/types';

export function FormResponsesByMembershipDataResolver(): IInjectable {
  return [
    'ApiService',
    '$stateParams',
    function FormsData(
      apiService: ApiService,
      $stateParams: StateParams
    ): IPromise<{ data: ACMEListResponse<FormsSummariesListItem> }> {
      return apiService.orders.forms.responses.membership({ membershipId: $stateParams.id });
    },
  ];
}
